module.exports = __webpack_public_path__ + "img/rule.168294d6.png";